import posthog from "posthog-js";

// PostHog Cloud (EU), free tier. Session recording is disabled outright —
// this app renders Aadhaar numbers, photos, and bank details on screen, and
// a recorder is the one feature that would capture that visually. Autocapture
// stays on for clicks/pageviews only; PostHog never captures <input> values
// by default, so it can't leak what someone typed into those forms either.
const TOKEN = "phc_oiupVe8NPh4DggTWPj996hpUXNyVg8RXLY7XfjtAVXHL";

let started = false;

export function initAnalytics() {
  if (started) return;
  started = true;
  posthog.init(TOKEN, {
    api_host: "https://eu.i.posthog.com",
    person_profiles: "identified_only",
    disable_session_recording: true,
    capture_pageview: true,
    autocapture: true,
  });
}

// Screens here are React view-state, not real URL routes, so PostHog's
// automatic $pageview (fired once, on script load) can't see navigation
// between them — call this from each bottom-nav tab change instead.
export function trackScreen(screen: string) {
  posthog.capture("$pageview", { screen });
}

// Ties events together by account without sending anything directly
// identifying (name/email/phone) as an analytics property — role and city
// are enough to segment traffic meaningfully.
export function identifyUser(userId: string, role: string, city: string | null) {
  posthog.identify(userId, { role, city: city ?? undefined });
}

export function resetAnalytics() {
  posthog.reset();
}
